export default __webpack_public_path__ + "static/media/shree-optics.1bb61c69.png";